// This file is auto-generated by scripts/generate-form-schema.ts
// DO NOT EDIT MANUALLY - run 'pnpm generate-schema' to regenerate

export type StaticFieldSchema = {
  key: string
  type: 'string' | 'number' | 'boolean' | 'object' | 'array' | 'enum'
  required: boolean
  component:
    | 'TextInput'
    | 'Select'
    | 'Checkbox'
    | 'Textarea'
    | 'NumberInput'
    | 'ArrayEditor'
  numberFormat?: 'integer' | 'float' | 'currency'
  options?:
    | Array<string>
    | Array<{ label: string; value: string; sublabel?: string }>
  nested?: Array<StaticFieldSchema>
  fullPath?: string
  description?: string
}

export const loanTypesResponseSchema: Array<StaticFieldSchema> = [
  {
    key: 'assetType',
    type: 'enum',
    required: true,
    component: 'Select',
    fullPath: 'assetType',
    options: [
      'personalClosedEndUnsecured',
      'personalOpenEndUnsecured',
      'personalClosedEndSecured',
      'personalOpenEndSecured',
      'motorMVRISC',
      'motorDirect',
      'motorLease',
      'businessClosedEndUnsecured',
      'businessOpenEndUnsecured',
      'businessClosedEndSecured',
      'businessOpenEndSecured',
    ],
  },
  {
    key: 'externalId',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'externalId',
  },
  {
    key: 'name',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'name',
  },
  {
    key: 'assetDisplayName',
    type: 'string',
    required: true,
    component: 'TextInput',
    fullPath: 'assetDisplayName',
  },
  {
    key: 'txDescriptorAssetDisplayName',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'txDescriptorAssetDisplayName',
  },
  {
    key: 'description',
    type: 'string',
    required: false,
    component: 'Textarea',
    fullPath: 'description',
  },
  {
    key: 'status',
    type: 'enum',
    required: false,
    component: 'Select',
    fullPath: 'status',
    options: ['inactive', 'active'],
  },
  {
    key: 'currency',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'currency',
  },
  {
    key: 'timezone',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'timezone',
  },
  {
    key: 'paymentAllowedWhenChargedOff',
    type: 'boolean',
    required: false,
    component: 'Checkbox',
    fullPath: 'paymentAllowedWhenChargedOff',
  },
  {
    key: 'paydayNotices',
    type: 'object',
    required: false,
    component: 'TextInput',
    fullPath: 'paydayNotices',
    nested: [
      {
        key: 'sendFirstPaymentWithdrawalNotice',
        type: 'boolean',
        required: false,
        component: 'Checkbox',
        fullPath: 'paydayNotices.sendFirstPaymentWithdrawalNotice',
      },
      {
        key: 'sendConsumerRightsNotice',
        type: 'boolean',
        required: false,
        component: 'Checkbox',
        fullPath: 'paydayNotices.sendConsumerRightsNotice',
      },
    ],
  },
  {
    key: 'futurePay',
    type: 'object',
    required: false,
    component: 'TextInput',
    fullPath: 'futurePay',
    nested: [
      {
        key: 'achDebitTiming',
        type: 'enum',
        required: false,
        component: 'Select',
        fullPath: 'futurePay.achDebitTiming',
        options: ['initiateOnDueDate', 'hitOnDueDate'],
      },
      {
        key: 'achDebitTimingShiftOnNonBusinessDay',
        type: 'enum',
        required: false,
        component: 'Select',
        fullPath: 'futurePay.achDebitTimingShiftOnNonBusinessDay',
        options: ['forward', 'backward'],
      },
      {
        key: 'overpaymentAmountLimitFactor',
        type: 'number',
        required: false,
        component: 'NumberInput',
        fullPath: 'futurePay.overpaymentAmountLimitFactor',
        numberFormat: 'currency',
      },
      {
        key: 'balanceCheck',
        type: 'object',
        required: false,
        component: 'TextInput',
        fullPath: 'futurePay.balanceCheck',
        nested: [
          {
            key: 'enabled',
            type: 'boolean',
            required: false,
            component: 'Checkbox',
            fullPath: 'futurePay.balanceCheck.enabled',
          },
          {
            key: 'checkOffsetDays',
            type: 'number',
            required: false,
            component: 'NumberInput',
            fullPath: 'futurePay.balanceCheck.checkOffsetDays',
            numberFormat: 'integer',
          },
          {
            key: 'thresholds',
            type: 'array',
            required: false,
            component: 'ArrayEditor',
            fullPath: 'futurePay.balanceCheck.thresholds',
            nested: [
              {
                key: '0',
                type: 'object',
                required: true,
                component: 'TextInput',
                fullPath: 'futurePay.balanceCheck.thresholds[0]',
                nested: [
                  {
                    key: 'zone',
                    type: 'enum',
                    required: false,
                    component: 'Select',
                    fullPath: 'futurePay.balanceCheck.thresholds[0].zone',
                    options: ['balanceRed', 'balanceYellow'],
                  },
                  {
                    key: 'value',
                    type: 'number',
                    required: false,
                    component: 'NumberInput',
                    fullPath: 'futurePay.balanceCheck.thresholds[0].value',
                    numberFormat: 'integer',
                  },
                ],
              },
            ],
          },
          {
            key: 'debitLogic',
            type: 'array',
            required: false,
            component: 'ArrayEditor',
            fullPath: 'futurePay.balanceCheck.debitLogic',
            nested: [
              {
                key: '0',
                type: 'object',
                required: true,
                component: 'TextInput',
                fullPath: 'futurePay.balanceCheck.debitLogic[0]',
                nested: [
                  {
                    key: 'condition',
                    type: 'enum',
                    required: false,
                    component: 'Select',
                    fullPath: 'futurePay.balanceCheck.debitLogic[0].condition',
                    options: [
                      'balanceRed',
                      'balanceYellow',
                      'balanceNA',
                      'balanceBroken',
                      'balanceGreen',
                    ],
                  },
                  {
                    key: 'action',
                    type: 'enum',
                    required: false,
                    component: 'Select',
                    fullPath: 'futurePay.balanceCheck.debitLogic[0].action',
                    options: ['cancel', 'debit', 'reschedule'],
                  },
                ],
              },
            ],
          },
          {
            key: 'rescheduleBufferInDays',
            type: 'number',
            required: false,
            component: 'NumberInput',
            fullPath: 'futurePay.balanceCheck.rescheduleBufferInDays',
            numberFormat: 'integer',
          },
          {
            key: 'rescheduleBufferDayType',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'futurePay.balanceCheck.rescheduleBufferDayType',
            options: ['calendar', 'business'],
          },
        ],
      },
    ],
  },
  {
    key: 'paymentHoldDays',
    type: 'object',
    required: false,
    component: 'TextInput',
    fullPath: 'paymentHoldDays',
    nested: [
      {
        key: 'holdDayType',
        type: 'enum',
        required: true,
        component: 'Select',
        fullPath: 'paymentHoldDays.holdDayType',
        options: ['calendar', 'business'],
      },
      {
        key: 'numHoldDays',
        type: 'number',
        required: true,
        component: 'NumberInput',
        fullPath: 'paymentHoldDays.numHoldDays',
        numberFormat: 'integer',
      },
    ],
  },
  {
    key: 'openToBuyCalculation',
    type: 'object',
    required: false,
    component: 'TextInput',
    fullPath: 'openToBuyCalculation',
    nested: [
      {
        key: 'calculationType',
        type: 'enum',
        required: false,
        component: 'Select',
        fullPath: 'openToBuyCalculation.calculationType',
        options: [
          'transactionStatus',
          'transactionHoldDays',
          'transactionStatusAndHoldDays',
        ],
      },
    ],
  },
  {
    key: 'fees',
    type: 'object',
    required: false,
    component: 'TextInput',
    fullPath: 'fees',
    nested: [
      {
        key: 'originationFeeChargeLogic',
        type: 'enum',
        required: false,
        component: 'Select',
        fullPath: 'fees.originationFeeChargeLogic',
        options: [
          '',
          'onTopPeriodicPayment',
          'blendWithPeriodicPayment',
          'chargedAtOrigination',
        ],
      },
      {
        key: 'originationFeeAPRCalcOverride',
        type: 'enum',
        required: false,
        component: 'Select',
        fullPath: 'fees.originationFeeAPRCalcOverride',
        options: ['noOverride', 'atOrigination'],
      },
      {
        key: 'originationFeeDisplayName',
        type: 'string',
        required: false,
        component: 'TextInput',
        fullPath: 'fees.originationFeeDisplayName',
      },
    ],
  },
  {
    key: 'refunds',
    type: 'object',
    required: false,
    component: 'TextInput',
    fullPath: 'refunds',
    nested: [
      {
        key: 'isRefundAllowed',
        type: 'boolean',
        required: false,
        component: 'Checkbox',
        fullPath: 'refunds.isRefundAllowed',
      },
    ],
  },
  {
    key: 'paymentWaterfall',
    type: 'object',
    required: false,
    component: 'TextInput',
    fullPath: 'paymentWaterfall',
    nested: [
      {
        key: 'single',
        type: 'array',
        required: false,
        component: 'ArrayEditor',
        fullPath: 'paymentWaterfall.single',
        nested: [
          {
            key: '0',
            type: 'object',
            required: true,
            component: 'TextInput',
            fullPath: 'paymentWaterfall.single[0]',
            nested: [
              {
                key: 'transactionType',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath: 'paymentWaterfall.single[0].transactionType',
                options: ['payment', 'serviceCredit'],
              },
              {
                key: 'loanStatus',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath: 'paymentWaterfall.single[0].loanStatus',
                options: ['active', 'accelerated', 'chargedOff'],
              },
              {
                key: 'balancesOrder',
                type: 'array',
                required: false,
                component: 'ArrayEditor',
                fullPath: 'paymentWaterfall.single[0].balancesOrder',
                nested: [
                  {
                    key: '0',
                    type: 'enum',
                    required: true,
                    component: 'Select',
                    fullPath: 'paymentWaterfall.single[0].balancesOrder[0]',
                    options: [
                      'overdueFee',
                      'overdueAccruedInterest',
                      'overduePrincipal',
                      'dueFee',
                      'dueAccruedInterest',
                      'duePrincipal',
                      'nonDueFee',
                      'nonDueAccruedInterest',
                      'nonDuePrincipal',
                      'chargedOffPrincipal',
                      'chargedOffAccruedInterest',
                      'chargedOffFee',
                      'nonAccrualFee',
                      'nonAccrualInterest',
                      'nonAccrualPrincipal',
                    ],
                  },
                ],
              },
              {
                key: 'feesOrder',
                type: 'array',
                required: false,
                component: 'ArrayEditor',
                fullPath: 'paymentWaterfall.single[0].feesOrder',
                nested: [
                  {
                    key: '0',
                    type: 'enum',
                    required: true,
                    component: 'Select',
                    fullPath: 'paymentWaterfall.single[0].feesOrder[0]',
                    options: [
                      'originationFee',
                      'drawFee',
                      'modificationFee',
                      'lateFee',
                      'membershipFee',
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        key: 'multi',
        type: 'array',
        required: false,
        component: 'ArrayEditor',
        fullPath: 'paymentWaterfall.multi',
        nested: [
          {
            key: '0',
            type: 'object',
            required: true,
            component: 'TextInput',
            fullPath: 'paymentWaterfall.multi[0]',
            nested: [
              {
                key: 'transactionType',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath: 'paymentWaterfall.multi[0].transactionType',
                options: ['payment', 'serviceCredit'],
              },
              {
                key: 'loansOrder',
                type: 'array',
                required: false,
                component: 'ArrayEditor',
                fullPath: 'paymentWaterfall.multi[0].loansOrder',
                nested: [
                  {
                    key: '0',
                    type: 'enum',
                    required: true,
                    component: 'Select',
                    fullPath: 'paymentWaterfall.multi[0].loansOrder[0]',
                    options: [
                      'highestInterestRate',
                      'lowestInterestRate',
                      'oldestLoanDate',
                      'newestLoanDate',
                      'highestOutstandingBalance',
                      'lowestOutstandingBalance',
                      'activeFirst',
                      'chargedOffFirst',
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    key: 'managedByPeach',
    type: 'boolean',
    required: false,
    component: 'Checkbox',
    fullPath: 'managedByPeach',
  },
  {
    key: 'automatedDebtValidationNotification',
    type: 'array',
    required: false,
    component: 'ArrayEditor',
    fullPath: 'automatedDebtValidationNotification',
    nested: [
      {
        key: '0',
        type: 'array',
        required: true,
        component: 'ArrayEditor',
        fullPath: 'automatedDebtValidationNotification[0]',
        nested: [
          {
            key: '0',
            type: 'string',
            required: true,
            component: 'TextInput',
            fullPath: 'automatedDebtValidationNotification[0][0]',
          },
        ],
      },
    ],
  },
  {
    key: 'creditReporting',
    type: 'object',
    required: false,
    component: 'TextInput',
    fullPath: 'creditReporting',
    nested: [
      {
        key: 'isCreditReportingAllowed',
        type: 'boolean',
        required: false,
        component: 'Checkbox',
        fullPath: 'creditReporting.isCreditReportingAllowed',
      },
      {
        key: 'metro2',
        type: 'object',
        required: false,
        component: 'TextInput',
        fullPath: 'creditReporting.metro2',
        nested: [
          {
            key: 'innovisProgramIdentifier',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'creditReporting.metro2.innovisProgramIdentifier',
          },
          {
            key: 'equifaxProgramIdentifier',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'creditReporting.metro2.equifaxProgramIdentifier',
          },
          {
            key: 'experianProgramIdentifier',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'creditReporting.metro2.experianProgramIdentifier',
          },
          {
            key: 'transunionProgramIdentifier',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'creditReporting.metro2.transunionProgramIdentifier',
          },
          {
            key: 'reporterName',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'creditReporting.metro2.reporterName',
          },
          {
            key: 'reporterAddress',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'creditReporting.metro2.reporterAddress',
          },
          {
            key: 'reporterTelephoneNumber',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'creditReporting.metro2.reporterTelephoneNumber',
          },
          {
            key: 'softwareVendorName',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'creditReporting.metro2.softwareVendorName',
          },
          {
            key: 'softwareVersionNumber',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'creditReporting.metro2.softwareVersionNumber',
          },
          {
            key: 'microBiltPrbcProgramIdentifier',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'creditReporting.metro2.microBiltPrbcProgramIdentifier',
          },
          {
            key: 'innovisIdentificationNumber',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'creditReporting.metro2.innovisIdentificationNumber',
          },
          {
            key: 'equifaxIdentificationNumber',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'creditReporting.metro2.equifaxIdentificationNumber',
          },
          {
            key: 'experianIdentificationNumber',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'creditReporting.metro2.experianIdentificationNumber',
          },
          {
            key: 'transunionIdentificationNumber',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'creditReporting.metro2.transunionIdentificationNumber',
          },
          {
            key: 'portfolioType',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'creditReporting.metro2.portfolioType',
            options: ['C', 'I', 'M', 'O', 'R'],
          },
          {
            key: 'accountType',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'creditReporting.metro2.accountType',
          },
          {
            key: 'interestTypeIndicator',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'creditReporting.metro2.interestTypeIndicator',
          },
          {
            key: 'creditorClassification',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'creditReporting.metro2.creditorClassification',
            options: [
              '01',
              '02',
              '03',
              '04',
              '05',
              '06',
              '07',
              '08',
              '09',
              '10',
              '11',
              '12',
              '13',
              '14',
              '15',
            ],
          },
          {
            key: 'skipSegments',
            type: 'array',
            required: false,
            component: 'ArrayEditor',
            fullPath: 'creditReporting.metro2.skipSegments',
            nested: [
              {
                key: '0',
                type: 'enum',
                required: true,
                component: 'Select',
                fullPath: 'creditReporting.metro2.skipSegments[0]',
                options: [
                  'header',
                  'baseSegment',
                  'k1Segment',
                  'k2Segment',
                  'l1Segment',
                ],
              },
            ],
          },
          {
            key: 'roundingMethod',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'creditReporting.metro2.roundingMethod',
            options: ['roundDownWhole', 'roundUpWhole'],
          },
        ],
      },
    ],
  },
  {
    key: 'useExternalIdInUI',
    type: 'boolean',
    required: false,
    component: 'Checkbox',
    fullPath: 'useExternalIdInUI',
  },
  {
    key: 'snapshots',
    type: 'object',
    required: false,
    component: 'TextInput',
    fullPath: 'snapshots',
    nested: [
      {
        key: 'reportDaysWhenPaidOff',
        type: 'number',
        required: false,
        component: 'NumberInput',
        fullPath: 'snapshots.reportDaysWhenPaidOff',
        numberFormat: 'integer',
      },
    ],
  },
  {
    key: 'extraFields',
    type: 'object',
    required: false,
    component: 'TextInput',
    fullPath: 'extraFields',
    nested: [],
  },
  {
    key: 'companyConfigOverride',
    type: 'object',
    required: false,
    component: 'TextInput',
    fullPath: 'companyConfigOverride',
    nested: [
      {
        key: 'legalName',
        type: 'string',
        required: false,
        component: 'TextInput',
        fullPath: 'companyConfigOverride.legalName',
      },
      {
        key: 'brandName',
        type: 'string',
        required: false,
        component: 'TextInput',
        fullPath: 'companyConfigOverride.brandName',
      },
      {
        key: 'support',
        type: 'object',
        required: false,
        component: 'TextInput',
        fullPath: 'companyConfigOverride.support',
        nested: [
          {
            key: 'phone',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'companyConfigOverride.support.phone',
          },
          {
            key: 'email',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'companyConfigOverride.support.email',
          },
          {
            key: 'departmentName',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'companyConfigOverride.support.departmentName',
          },
          {
            key: 'mailingAddress',
            type: 'object',
            required: false,
            component: 'TextInput',
            fullPath: 'companyConfigOverride.support.mailingAddress',
            nested: [
              {
                key: 'addressLine1',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath:
                  'companyConfigOverride.support.mailingAddress.addressLine1',
              },
              {
                key: 'addressLine2',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath:
                  'companyConfigOverride.support.mailingAddress.addressLine2',
              },
              {
                key: 'city',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath: 'companyConfigOverride.support.mailingAddress.city',
              },
              {
                key: 'countyOrRegion',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath:
                  'companyConfigOverride.support.mailingAddress.countyOrRegion',
              },
              {
                key: 'state',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath: 'companyConfigOverride.support.mailingAddress.state',
              },
              {
                key: 'postalCode',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath:
                  'companyConfigOverride.support.mailingAddress.postalCode',
              },
              {
                key: 'country',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath:
                  'companyConfigOverride.support.mailingAddress.country',
              },
              {
                key: 'POBox',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath: 'companyConfigOverride.support.mailingAddress.POBox',
              },
              {
                key: 'timezone',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath:
                  'companyConfigOverride.support.mailingAddress.timezone',
              },
            ],
          },
          {
            key: 'outboundCallRecordingConsentScript',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath:
              'companyConfigOverride.support.outboundCallRecordingConsentScript',
          },
          {
            key: 'privacyPolicyUrl',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'companyConfigOverride.support.privacyPolicyUrl',
          },
          {
            key: 'phoneSupportPleaseHoldMessage',
            type: 'string',
            required: false,
            component: 'Textarea',
            fullPath:
              'companyConfigOverride.support.phoneSupportPleaseHoldMessage',
          },
          {
            key: 'enableVoicemailWhenClosed',
            type: 'boolean',
            required: false,
            component: 'Checkbox',
            fullPath: 'companyConfigOverride.support.enableVoicemailWhenClosed',
          },
          {
            key: 'phoneSupportClosedMessage',
            type: 'string',
            required: false,
            component: 'Textarea',
            fullPath: 'companyConfigOverride.support.phoneSupportClosedMessage',
          },
          {
            key: 'phoneSupportDisabledMessage',
            type: 'string',
            required: false,
            component: 'Textarea',
            fullPath:
              'companyConfigOverride.support.phoneSupportDisabledMessage',
          },
          {
            key: 'phoneSupportClosedLeaveVoicemailMessage',
            type: 'string',
            required: false,
            component: 'Textarea',
            fullPath:
              'companyConfigOverride.support.phoneSupportClosedLeaveVoicemailMessage',
          },
          {
            key: 'enableVoicemailWhenNoAgents',
            type: 'boolean',
            required: false,
            component: 'Checkbox',
            fullPath:
              'companyConfigOverride.support.enableVoicemailWhenNoAgents',
          },
          {
            key: 'phoneSupportNoAgentsLeaveVoicemailMessage',
            type: 'string',
            required: false,
            component: 'Textarea',
            fullPath:
              'companyConfigOverride.support.phoneSupportNoAgentsLeaveVoicemailMessage',
          },
          {
            key: 'recordAllInboundVoiceCalls',
            type: 'boolean',
            required: false,
            component: 'Checkbox',
            fullPath:
              'companyConfigOverride.support.recordAllInboundVoiceCalls',
          },
          {
            key: 'recordAllOutboundVoiceCalls',
            type: 'boolean',
            required: false,
            component: 'Checkbox',
            fullPath:
              'companyConfigOverride.support.recordAllOutboundVoiceCalls',
          },
          {
            key: 'textSupportRejectUnknownNumberMessage',
            type: 'string',
            required: false,
            component: 'Textarea',
            fullPath:
              'companyConfigOverride.support.textSupportRejectUnknownNumberMessage',
          },
          {
            key: 'textSupportPleaseWaitMessage',
            type: 'string',
            required: false,
            component: 'Textarea',
            fullPath:
              'companyConfigOverride.support.textSupportPleaseWaitMessage',
          },
          {
            key: 'textSupportClosedPleaseWaitMessage',
            type: 'string',
            required: false,
            component: 'Textarea',
            fullPath:
              'companyConfigOverride.support.textSupportClosedPleaseWaitMessage',
          },
          {
            key: 'textSupportFindNewAgentPleaseWaitMessage',
            type: 'string',
            required: false,
            component: 'Textarea',
            fullPath:
              'companyConfigOverride.support.textSupportFindNewAgentPleaseWaitMessage',
          },
          {
            key: 'textSupportDisabledMessage',
            type: 'string',
            required: false,
            component: 'Textarea',
            fullPath:
              'companyConfigOverride.support.textSupportDisabledMessage',
          },
        ],
      },
      {
        key: 'openHours',
        type: 'object',
        required: false,
        component: 'TextInput',
        fullPath: 'companyConfigOverride.openHours',
        nested: [
          {
            key: 'businessHours',
            type: 'object',
            required: false,
            component: 'TextInput',
            fullPath: 'companyConfigOverride.openHours.businessHours',
            nested: [
              {
                key: 'normal',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath:
                  'companyConfigOverride.openHours.businessHours.normal',
              },
              {
                key: 'holidays',
                type: 'array',
                required: false,
                component: 'ArrayEditor',
                fullPath:
                  'companyConfigOverride.openHours.businessHours.holidays',
                nested: [
                  {
                    key: '0',
                    type: 'object',
                    required: true,
                    component: 'TextInput',
                    fullPath:
                      'companyConfigOverride.openHours.businessHours.holidays[0]',
                    nested: [
                      {
                        key: 'date',
                        type: 'string',
                        required: false,
                        component: 'TextInput',
                        fullPath:
                          'companyConfigOverride.openHours.businessHours.holidays[0].date',
                      },
                      {
                        key: 'name',
                        type: 'string',
                        required: true,
                        component: 'TextInput',
                        fullPath:
                          'companyConfigOverride.openHours.businessHours.holidays[0].name',
                      },
                      {
                        key: 'hours',
                        type: 'string',
                        required: false,
                        component: 'TextInput',
                        fullPath:
                          'companyConfigOverride.openHours.businessHours.holidays[0].hours',
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        key: 'brandAssets',
        type: 'object',
        required: false,
        component: 'TextInput',
        fullPath: 'companyConfigOverride.brandAssets',
        nested: [
          {
            key: 'logos',
            type: 'object',
            required: false,
            component: 'TextInput',
            fullPath: 'companyConfigOverride.brandAssets.logos',
            nested: [
              {
                key: 'primary',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath: 'companyConfigOverride.brandAssets.logos.primary',
              },
              {
                key: 'small',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath: 'companyConfigOverride.brandAssets.logos.small',
              },
              {
                key: 'appLargeCentered',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath:
                  'companyConfigOverride.brandAssets.logos.appLargeCentered',
              },
              {
                key: 'appRegularNavigation',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath:
                  'companyConfigOverride.brandAssets.logos.appRegularNavigation',
              },
              {
                key: 'appCompactNavigation',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath:
                  'companyConfigOverride.brandAssets.logos.appCompactNavigation',
              },
            ],
          },
          {
            key: 'colors',
            type: 'object',
            required: false,
            component: 'TextInput',
            fullPath: 'companyConfigOverride.brandAssets.colors',
            nested: [
              {
                key: 'primary',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath: 'companyConfigOverride.brandAssets.colors.primary',
              },
              {
                key: 'secondary',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath: 'companyConfigOverride.brandAssets.colors.secondary',
              },
              {
                key: 'tertiary',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath: 'companyConfigOverride.brandAssets.colors.tertiary',
              },
              {
                key: 'lighten',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath: 'companyConfigOverride.brandAssets.colors.lighten',
              },
              {
                key: 'button',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath: 'companyConfigOverride.brandAssets.colors.button',
              },
              {
                key: 'link',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath: 'companyConfigOverride.brandAssets.colors.link',
              },
              {
                key: 'secondButton',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath:
                  'companyConfigOverride.brandAssets.colors.secondButton',
              },
              {
                key: 'secondButtonBackground',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath:
                  'companyConfigOverride.brandAssets.colors.secondButtonBackground',
              },
            ],
          },
          {
            key: 'copies',
            type: 'object',
            required: false,
            component: 'TextInput',
            fullPath: 'companyConfigOverride.brandAssets.copies',
            nested: [
              {
                key: 'consent',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath: 'companyConfigOverride.brandAssets.copies.consent',
              },
              {
                key: 'disclosures',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath:
                  'companyConfigOverride.brandAssets.copies.disclosures',
              },
            ],
          },
        ],
      },
      {
        key: 'links',
        type: 'object',
        required: false,
        component: 'TextInput',
        fullPath: 'companyConfigOverride.links',
        nested: [
          {
            key: 'helpUrl',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'companyConfigOverride.links.helpUrl',
          },
          {
            key: 'termsOfUseUrl',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'companyConfigOverride.links.termsOfUseUrl',
          },
          {
            key: 'privacyPolicyUrl',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'companyConfigOverride.links.privacyPolicyUrl',
          },
          {
            key: 'eSignDisclosureUrl',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'companyConfigOverride.links.eSignDisclosureUrl',
          },
        ],
      },
      {
        key: 'showPoweredByPeach',
        type: 'boolean',
        required: false,
        component: 'Checkbox',
        fullPath: 'companyConfigOverride.showPoweredByPeach',
      },
      {
        key: 'ui',
        type: 'object',
        required: false,
        component: 'TextInput',
        fullPath: 'companyConfigOverride.ui',
        nested: [
          {
            key: 'directPaymentToDraw',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'companyConfigOverride.ui.directPaymentToDraw',
            options: ['', 'shown'],
          },
          {
            key: 'mobileFooter',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'companyConfigOverride.ui.mobileFooter',
            options: ['', 'hidden'],
          },
          {
            key: 'mobileHeader',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'companyConfigOverride.ui.mobileHeader',
            options: ['', 'hidden'],
          },
          {
            key: 'mobileDisclosures',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'companyConfigOverride.ui.mobileDisclosures',
            options: ['', 'hidden'],
          },
          {
            key: 'manageAutopayPage',
            type: 'object',
            required: false,
            component: 'TextInput',
            fullPath: 'companyConfigOverride.ui.manageAutopayPage',
            nested: [
              {
                key: 'minimumPaymentDue',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath:
                  'companyConfigOverride.ui.manageAutopayPage.minimumPaymentDue',
                options: ['', 'hidden'],
              },
              {
                key: 'statementBalance',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath:
                  'companyConfigOverride.ui.manageAutopayPage.statementBalance',
                options: ['', 'hidden'],
              },
            ],
          },
          {
            key: 'makePaymentPage',
            type: 'object',
            required: false,
            component: 'TextInput',
            fullPath: 'companyConfigOverride.ui.makePaymentPage',
            nested: [
              {
                key: 'remainingBalance',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath:
                  'companyConfigOverride.ui.makePaymentPage.remainingBalance',
                options: ['', 'hidden'],
              },
            ],
          },
          {
            key: 'loginPage',
            type: 'object',
            required: false,
            component: 'TextInput',
            fullPath: 'companyConfigOverride.ui.loginPage',
            nested: [
              {
                key: 'fallbackAuthLink',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath: 'companyConfigOverride.ui.loginPage.fallbackAuthLink',
                options: ['', 'hidden'],
              },
            ],
          },
          {
            key: 'managePaymentMethodsPage',
            type: 'object',
            required: false,
            component: 'TextInput',
            fullPath: 'companyConfigOverride.ui.managePaymentMethodsPage',
            nested: [
              {
                key: 'borrower',
                type: 'object',
                required: false,
                component: 'TextInput',
                fullPath:
                  'companyConfigOverride.ui.managePaymentMethodsPage.borrower',
                nested: [
                  {
                    key: 'check',
                    type: 'enum',
                    required: false,
                    component: 'Select',
                    fullPath:
                      'companyConfigOverride.ui.managePaymentMethodsPage.borrower.check',
                    options: ['', 'hidden'],
                  },
                  {
                    key: 'creditCard',
                    type: 'enum',
                    required: false,
                    component: 'Select',
                    fullPath:
                      'companyConfigOverride.ui.managePaymentMethodsPage.borrower.creditCard',
                    options: ['', 'hidden'],
                  },
                  {
                    key: 'debitCard',
                    type: 'enum',
                    required: false,
                    component: 'Select',
                    fullPath:
                      'companyConfigOverride.ui.managePaymentMethodsPage.borrower.debitCard',
                    options: ['', 'hidden'],
                  },
                  {
                    key: 'payroll',
                    type: 'enum',
                    required: false,
                    component: 'Select',
                    fullPath:
                      'companyConfigOverride.ui.managePaymentMethodsPage.borrower.payroll',
                    options: ['', 'hidden'],
                  },
                  {
                    key: 'paymentNetwork',
                    type: 'enum',
                    required: false,
                    component: 'Select',
                    fullPath:
                      'companyConfigOverride.ui.managePaymentMethodsPage.borrower.paymentNetwork',
                    options: ['', 'hidden'],
                  },
                  {
                    key: 'wire',
                    type: 'enum',
                    required: false,
                    component: 'Select',
                    fullPath:
                      'companyConfigOverride.ui.managePaymentMethodsPage.borrower.wire',
                    options: ['', 'hidden'],
                  },
                  {
                    key: 'moneyOrder',
                    type: 'enum',
                    required: false,
                    component: 'Select',
                    fullPath:
                      'companyConfigOverride.ui.managePaymentMethodsPage.borrower.moneyOrder',
                    options: ['', 'hidden'],
                  },
                  {
                    key: 'deleteButton',
                    type: 'enum',
                    required: false,
                    component: 'Select',
                    fullPath:
                      'companyConfigOverride.ui.managePaymentMethodsPage.borrower.deleteButton',
                    options: ['', 'hidden'],
                  },
                ],
              },
              {
                key: 'agent',
                type: 'object',
                required: false,
                component: 'TextInput',
                fullPath:
                  'companyConfigOverride.ui.managePaymentMethodsPage.agent',
                nested: [
                  {
                    key: 'check',
                    type: 'enum',
                    required: false,
                    component: 'Select',
                    fullPath:
                      'companyConfigOverride.ui.managePaymentMethodsPage.agent.check',
                    options: ['', 'hidden'],
                  },
                  {
                    key: 'creditCard',
                    type: 'enum',
                    required: false,
                    component: 'Select',
                    fullPath:
                      'companyConfigOverride.ui.managePaymentMethodsPage.agent.creditCard',
                    options: ['', 'hidden'],
                  },
                  {
                    key: 'debitCard',
                    type: 'enum',
                    required: false,
                    component: 'Select',
                    fullPath:
                      'companyConfigOverride.ui.managePaymentMethodsPage.agent.debitCard',
                    options: ['', 'hidden'],
                  },
                  {
                    key: 'payroll',
                    type: 'enum',
                    required: false,
                    component: 'Select',
                    fullPath:
                      'companyConfigOverride.ui.managePaymentMethodsPage.agent.payroll',
                    options: ['', 'hidden'],
                  },
                  {
                    key: 'paymentNetwork',
                    type: 'enum',
                    required: false,
                    component: 'Select',
                    fullPath:
                      'companyConfigOverride.ui.managePaymentMethodsPage.agent.paymentNetwork',
                    options: ['', 'hidden'],
                  },
                  {
                    key: 'wire',
                    type: 'enum',
                    required: false,
                    component: 'Select',
                    fullPath:
                      'companyConfigOverride.ui.managePaymentMethodsPage.agent.wire',
                    options: ['', 'hidden'],
                  },
                  {
                    key: 'moneyOrder',
                    type: 'enum',
                    required: false,
                    component: 'Select',
                    fullPath:
                      'companyConfigOverride.ui.managePaymentMethodsPage.agent.moneyOrder',
                    options: ['', 'hidden'],
                  },
                  {
                    key: 'deleteButton',
                    type: 'enum',
                    required: false,
                    component: 'Select',
                    fullPath:
                      'companyConfigOverride.ui.managePaymentMethodsPage.agent.deleteButton',
                    options: ['', 'hidden'],
                  },
                ],
              },
            ],
          },
          {
            key: 'help',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'companyConfigOverride.ui.help',
            options: ['', 'hidden'],
          },
          {
            key: 'signOut',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'companyConfigOverride.ui.signOut',
            options: ['', 'hidden'],
          },
          {
            key: 'accountSettings',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'companyConfigOverride.ui.accountSettings',
            options: ['', 'hidden'],
          },
          {
            key: 'contactUs',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'companyConfigOverride.ui.contactUs',
            options: ['', 'hidden'],
          },
          {
            key: 'loanOptions',
            type: 'object',
            required: false,
            component: 'TextInput',
            fullPath: 'companyConfigOverride.ui.loanOptions',
            nested: [
              {
                key: 'managePaymentMethods',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath:
                  'companyConfigOverride.ui.loanOptions.managePaymentMethods',
                options: ['', 'hidden'],
              },
              {
                key: 'makePayment',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath: 'companyConfigOverride.ui.loanOptions.makePayment',
                options: ['', 'hidden'],
              },
              {
                key: 'changeDueDate',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath: 'companyConfigOverride.ui.loanOptions.changeDueDate',
                options: ['', 'hidden'],
              },
              {
                key: 'getPayoffStatement',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath:
                  'companyConfigOverride.ui.loanOptions.getPayoffStatement',
                options: ['', 'hidden'],
              },
              {
                key: 'changeNickname',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath: 'companyConfigOverride.ui.loanOptions.changeNickname',
                options: ['', 'hidden'],
              },
              {
                key: 'manageAutopay',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath: 'companyConfigOverride.ui.loanOptions.manageAutopay',
                options: ['', 'hidden'],
              },
              {
                key: 'drawFunds',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath: 'companyConfigOverride.ui.loanOptions.drawFunds',
                options: ['', 'hidden'],
              },
            ],
          },
          {
            key: 'accountSettingsPage',
            type: 'object',
            required: false,
            component: 'TextInput',
            fullPath: 'companyConfigOverride.ui.accountSettingsPage',
            nested: [
              {
                key: 'profile',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath:
                  'companyConfigOverride.ui.accountSettingsPage.profile',
                options: ['', 'hidden'],
              },
              {
                key: 'contactInformation',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath:
                  'companyConfigOverride.ui.accountSettingsPage.contactInformation',
                options: ['', 'hidden'],
              },
              {
                key: 'commPreferences',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath:
                  'companyConfigOverride.ui.accountSettingsPage.commPreferences',
                options: ['', 'hidden'],
              },
              {
                key: 'additionalContacts',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath:
                  'companyConfigOverride.ui.accountSettingsPage.additionalContacts',
                options: ['', 'hidden'],
              },
              {
                key: 'paymentMethods',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath:
                  'companyConfigOverride.ui.accountSettingsPage.paymentMethods',
                options: ['', 'hidden'],
              },
            ],
          },
          {
            key: 'accountSummaryPage',
            type: 'object',
            required: false,
            component: 'TextInput',
            fullPath: 'companyConfigOverride.ui.accountSummaryPage',
            nested: [
              {
                key: 'summary',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath: 'companyConfigOverride.ui.accountSummaryPage.summary',
                options: ['', 'hidden'],
              },
              {
                key: 'loanTerms',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath:
                  'companyConfigOverride.ui.accountSummaryPage.loanTerms',
                options: ['', 'hidden'],
              },
              {
                key: 'balancesDetails',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath:
                  'companyConfigOverride.ui.accountSummaryPage.balancesDetails',
                options: ['', 'hidden'],
              },
              {
                key: 'promotions',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath:
                  'companyConfigOverride.ui.accountSummaryPage.promotions',
                options: ['', 'hidden'],
              },
              {
                key: 'merchantDetails',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath:
                  'companyConfigOverride.ui.accountSummaryPage.merchantDetails',
                options: ['', 'hidden'],
              },
              {
                key: 'cardDetails',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath:
                  'companyConfigOverride.ui.accountSummaryPage.cardDetails',
                options: ['', 'hidden'],
              },
            ],
          },
          {
            key: 'caseTypeOrdering',
            type: 'array',
            required: false,
            component: 'ArrayEditor',
            fullPath: 'companyConfigOverride.ui.caseTypeOrdering',
            nested: [
              {
                key: '0',
                type: 'object',
                required: true,
                component: 'TextInput',
                fullPath: 'companyConfigOverride.ui.caseTypeOrdering[0]',
                nested: [
                  {
                    key: 'category',
                    type: 'string',
                    required: false,
                    component: 'TextInput',
                    fullPath:
                      'companyConfigOverride.ui.caseTypeOrdering[0].category',
                  },
                  {
                    key: 'caseTypes',
                    type: 'array',
                    required: false,
                    component: 'ArrayEditor',
                    fullPath:
                      'companyConfigOverride.ui.caseTypeOrdering[0].caseTypes',
                    nested: [
                      {
                        key: '0',
                        type: 'string',
                        required: true,
                        component: 'TextInput',
                        fullPath:
                          'companyConfigOverride.ui.caseTypeOrdering[0].caseTypes[0]',
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            key: 'agentDashboardTools',
            type: 'object',
            required: false,
            component: 'TextInput',
            fullPath: 'companyConfigOverride.ui.agentDashboardTools',
            nested: [
              {
                key: 'enabled',
                type: 'boolean',
                required: false,
                component: 'Checkbox',
                fullPath:
                  'companyConfigOverride.ui.agentDashboardTools.enabled',
              },
              {
                key: 'dashboardToolDetails',
                type: 'array',
                required: false,
                component: 'ArrayEditor',
                fullPath:
                  'companyConfigOverride.ui.agentDashboardTools.dashboardToolDetails',
                nested: [
                  {
                    key: '0',
                    type: 'object',
                    required: true,
                    component: 'TextInput',
                    fullPath:
                      'companyConfigOverride.ui.agentDashboardTools.dashboardToolDetails[0]',
                    nested: [
                      {
                        key: 'name',
                        type: 'string',
                        required: false,
                        component: 'TextInput',
                        fullPath:
                          'companyConfigOverride.ui.agentDashboardTools.dashboardToolDetails[0].name',
                      },
                      {
                        key: 'url',
                        type: 'string',
                        required: false,
                        component: 'TextInput',
                        fullPath:
                          'companyConfigOverride.ui.agentDashboardTools.dashboardToolDetails[0].url',
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            key: 'websiteTitle',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'companyConfigOverride.ui.websiteTitle',
          },
          {
            key: 'favicon',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'companyConfigOverride.ui.favicon',
          },
          {
            key: 'projectSlug',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'companyConfigOverride.ui.projectSlug',
          },
          {
            key: 'phoneDisclosureNote',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'companyConfigOverride.ui.phoneDisclosureNote',
            options: ['', 'shown'],
          },
          {
            key: 'analyticsScript',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'companyConfigOverride.ui.analyticsScript',
          },
          {
            key: 'headScripts',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'companyConfigOverride.ui.headScripts',
          },
          {
            key: 'eSignDisclosure',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'companyConfigOverride.ui.eSignDisclosure',
            options: ['', 'hidden'],
          },
          {
            key: 'termsOfUse',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'companyConfigOverride.ui.termsOfUse',
            options: ['', 'hidden'],
          },
          {
            key: 'privacyPolicy',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'companyConfigOverride.ui.privacyPolicy',
            options: ['', 'hidden'],
          },
          {
            key: 'dashboard',
            type: 'object',
            required: false,
            component: 'TextInput',
            fullPath: 'companyConfigOverride.ui.dashboard',
            nested: [
              {
                key: 'cases',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath: 'companyConfigOverride.ui.dashboard.cases',
                options: ['', 'hidden'],
              },
              {
                key: 'interactions',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath: 'companyConfigOverride.ui.dashboard.interactions',
                options: ['', 'hidden'],
              },
            ],
          },
        ],
      },
      {
        key: 'timezone',
        type: 'string',
        required: false,
        component: 'TextInput',
        fullPath: 'companyConfigOverride.timezone',
      },
      {
        key: 'collections',
        type: 'object',
        required: false,
        component: 'TextInput',
        fullPath: 'companyConfigOverride.collections',
        nested: [
          {
            key: 'autoInitiate',
            type: 'object',
            required: false,
            component: 'TextInput',
            fullPath: 'companyConfigOverride.collections.autoInitiate',
            nested: [
              {
                key: 'enableReviewTask',
                type: 'boolean',
                required: false,
                component: 'Checkbox',
                fullPath:
                  'companyConfigOverride.collections.autoInitiate.enableReviewTask',
              },
            ],
          },
        ],
      },
    ],
  },
] as const

export const getFieldSchema = (path: string): StaticFieldSchema | undefined => {
  const findByPath = (
    fields: Array<StaticFieldSchema>,
    targetPath: string,
  ): StaticFieldSchema | undefined => {
    for (const field of fields) {
      if (field.fullPath === targetPath) {
        return field
      }
      if (field.nested) {
        const found = findByPath(field.nested, targetPath)
        if (found) return found
      }
    }
    return undefined
  }

  return findByPath(loanTypesResponseSchema, path)
}

export const getAllPaths = (): Array<string> => {
  const extractPaths = (fields: Array<StaticFieldSchema>): Array<string> => {
    const paths: Array<string> = []
    for (const field of fields) {
      if (field.fullPath) {
        paths.push(field.fullPath)
      }
      if (field.nested) {
        paths.push(...extractPaths(field.nested))
      }
    }
    return paths
  }

  return extractPaths(loanTypesResponseSchema)
}
